import { render, staticRenderFns } from "./DefaultPrintFormItem.vue?vue&type=template&id=3aae8b42&scoped=true"
import script from "./DefaultPrintFormItem.vue?vue&type=script&lang=js"
export * from "./DefaultPrintFormItem.vue?vue&type=script&lang=js"
import style0 from "./DefaultPrintFormItem.vue?vue&type=style&index=0&id=3aae8b42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae8b42",
  null
  
)

export default component.exports